import { useState } from "react";

const navItems = [
  { label: "今日新账", href: "#today" },
  { label: "考古时间线", href: "#timeline" },
  { label: "早年言论", href: "#quotes" },
  { label: "旧账卷宗", href: "#topics" },
  { label: "深度专题", href: "#dossier" },
];

export default function Masthead() {
  const [open, setOpen] = useState(false);

  return (
    <header className="bg-[#faf5eb]">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        {/* 报头上栏：卷号 / 日期 */}
        <div className="flex items-center justify-between border-b border-[#e3d7bd] pt-3 pb-3 text-[11px] tracking-widest text-[#6f6552]">
          <span className="hidden sm:inline">呱呱黑料 · 旧账刊</span>
          <span className="hidden md:inline">归档台第 08 卷</span>
          <span className="sm:hidden">旧账刊第 08 卷</span>
          <span className="flex items-center gap-2">
            <span className="hidden text-[#978a72] sm:inline">壹份慢慢翻的历史旧账</span>
            <span>2026 年 9 月 8 日 · 周二</span>
          </span>
        </div>

        {/* 刊头大标题 */}
        <div className="relative py-8 md:py-10">
          <h1 className="font-display text-center text-4xl font-black tracking-[0.08em] text-[#1a160e] md:text-6xl">
            呱呱黑料
          </h1>
          <p className="mt-3 text-center text-[11px] tracking-[0.5em] text-[#6f6552] md:text-xs">
            陈年往事 · 早年言论 · 黑历史后续
          </p>
          <button
            type="button"
            aria-label="展开目录"
            onClick={() => setOpen((v) => !v)}
            className="absolute right-0 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center border border-[#e3d7bd] text-[#6f6552] lg:hidden"
          >
            <i className={`text-lg ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
          </button>
        </div>

        {/* 目录导航（桌面） */}
        <nav className="hidden items-center justify-between gap-4 border-t border-[#1a160e] pt-3 pb-3 lg:flex" aria-label="首页栏目">
          <a
            href="#download"
            className="flex items-center gap-1.5 whitespace-nowrap bg-[#b1401f] px-3 py-1.5 text-xs font-medium text-[#faf5eb] transition hover:bg-[#852f12]"
          >
            <i className="ri-download-2-line text-sm" aria-hidden="true"></i>
            下载离线卷
          </a>
          <div className="flex items-center gap-6 text-sm tracking-wide text-[#1a160e]">
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                className="whitespace-nowrap transition hover:text-[#b1401f]"
              >
                {it.label}
              </a>
            ))}
          </div>
          <button
            type="button"
            className="flex shrink-0 cursor-pointer items-center gap-1.5 border-b border-transparent text-sm text-[#6f6552] transition hover:border-[#b1401f] hover:text-[#1a160e]"
          >
            <i className="ri-search-line text-base" aria-hidden="true"></i>
            <span className="whitespace-nowrap">检索旧账</span>
          </button>
        </nav>

        {/* 目录导航（移动折叠） */}
        {open && (
          <nav className="flex flex-col gap-1 border-t border-[#e3d7bd] pt-3 pb-3 lg:hidden" aria-label="首页栏目（移动）">
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between border-b border-[#e3d7bd] py-2.5 text-sm text-[#1a160e]"
              >
                <span>{it.label}</span>
                <i className="ri-arrow-right-s-line text-[#978a72]" aria-hidden="true"></i>
              </a>
            ))}
            <a
              href="#download"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-2 bg-[#b1401f] py-2.5 text-sm font-medium text-[#faf5eb]"
            >
              <i className="ri-download-2-line text-base" aria-hidden="true"></i>
              下载离线卷
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}